import en from './en';
import es from './es';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  es,
  en,
};
